<div
  class="html-container small-text"
  [ngStyle]="style"
  [innerHTML]="htmlValueSafe"
></div>
